module.exports = __webpack_public_path__ + "images/issue-type-stop.1acb9984489b63e944284a19a33cc5de.png";